export default "__VITE_ASSET__3dacb87a__"